const isLocalStorageAvailable = () => {
  try {
    localStorage.setItem('test_key', 'storage_test');
    localStorage.removeItem('test_key');
    return true;
  } catch (e) {
    return false;
  }
};

const inMemoryStorageService = () => {
  let inMemoryStorage = {};

  return {
    get: (key: string, callback?: (...args: any[]) => void) => {
      const storageItem = inMemoryStorage[key];
      if (storageItem) {
        return storageItem;
      }
      if (typeof callback === 'function') {
        return callback();
      }
      return storageItem;
    },
    set: (key: string, value: string) => {
      inMemoryStorage[key] = value;
    },
    delete: (key: string) => {
      inMemoryStorage[key] = undefined;
    },
    clear: () => {
      inMemoryStorage = {};
    },
  };
};

const localStorageService = () => ({
  get: (key: string, callback?: (...args: any[]) => void) => {
    const storageItem = localStorage.getItem(key);
    if (storageItem) {
      return storageItem;
    }
    if (typeof callback === 'function') {
      return callback();
    }
    return storageItem;
  },
  set: (key: string, value: string) => {
    localStorage.setItem(key, value);
  },
  delete: (key: string) => {
    localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  },
});

export default isLocalStorageAvailable()
  ? localStorageService()
  : inMemoryStorageService();
